    <template>
        <div class="roles-admin-page">
            <div class="title-block">
                <h2>Роли</h2>
                <span class="counter">{{ roles.length }}</span>
            </div>

            <my-loader v-if="isLoading && roles.length === 0"></my-loader>

            <div v-else class="table-wrap">
                <table v-if="filteredRoles.length" class="roles-table">
                    <colgroup>
                        <col class="col-id" />
                        <col class="col-name" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Наименование</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="role in filteredRoles" :key="role.id" @click="openEdit(role)" class="row-card">
                            <td :title="role.id">{{ role.id || '—' }}</td>
                            <td :title="role.name">{{ role.name || '—' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="panelOpen" class="modal-overlay" @click.self="closePanel">
                <div class="modal">
                    <div class="drawer-header">
                        <div>
                            <h2>{{ drawerMode === 'create' ? 'Добавить роль' : 'Редактирование' }}</h2>
                            <span v-if="drawerMode === 'edit'" class="drawer-subtitle">
                                {{ 'Id: ' + form.id + ' | Текущее наименование: ' + form.name }}
                            </span>
                        </div>
                        <button class="close-btn" type="button" @click="closePanel">×</button>
                    </div>
                    <form class="drawer-form" @submit.prevent="saveRole">
                        <label class="field wid">
                            <span>Поле редактирования наименования роли:</span>
                            <input v-model.trim="form.name" class="input" type="text" required />
                        </label>

                        <div class="right-editor-grid">
                            <group-multi-select v-model="form.permissions" :options="roleItemsOptions"
                                title="Доступные права для роли." placeholder="Поиск по названию."
                                empty-text="Права для роли не заданы." unknown-label="Права для роли." />
                        </div>

                        <div class="drawer-actions wide">
                            <button class="btn primary" type="submit" :disabled="saving">
                                {{ saving ? 'Сохраняем...' : 'Сохранить' }}
                            </button>
                            <button class="btn" type="button" @click="closePanel">Отмена</button>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    </template>

<script>
import { computed, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import GroupMultiSelect from '../../admin/distributor-routing/GroupMultiSelect.vue';
import { createToaster } from '@meforma/vue-toaster';

function blankform() {
    return {
        id: null,
        name: '',
        permissions: [],
    }
}

function normalizeOptional(value) {
    if (value === '' || value === undefined) {
        return null;
    }
    return value;
}

export default {
    name: 'RoleList',
    components: { GroupMultiSelect },
    setup() {
        const store = useStore();
        const roles = computed(() => store.state.user.roles_title || []);
        const form = reactive(blankform());
        const drawerMode = ref('create');
        const panelOpen = ref(false);
        const saving = ref(false);
        const toater = createToaster();

        onMounted(() => {
            store.dispatch('getPermissionsCatalog');
        });

        const FALLBACK_PERMISSIONS = [
            { code: 'ALL', label: 'Все права' },
            { code: 'CREATE_USER', label: 'Создание пользователя' },
            { code: 'DELETE_USER', label: 'Удаление пользователя' },
            { code: 'UPDATE_USER', label: 'Обновление пользователя' },
            { code: 'users.admin', label: 'Пользователи: администратор' },
            { code: 'users.impersonate', label: 'Вход под другим пользователем (имперсонализация)' },
            { code: 'CREATE_CARGO', label: 'Создание груза' },
            { code: 'UPDATE_CARGO', label: 'Обновление груза' },
            { code: 'RESOLUTION', label: 'Резолюция' },
            { code: 'memory.base_rates', label: 'Базовые тарифы' },
            { code: 'memory.trading_rates.read', label: 'Торговые ставки: просмотр' },
            { code: 'memory.trading_rates.write', label: 'Торговые ставки: редактирование' },
            { code: 'distribution.write', label: 'Распределение: действия с рейсами (в работу, очередь, закрытие)' },
            { code: 'distribution.admin', label: 'Распределение: администратор' },
            { code: 'advance.admin', label: 'Авансирование: бюджеты, проведение и отмена операций' },
            { code: 'distribution.approvals', label: 'Согласование тарифа (распределение)' },
            { code: 'distributor.admin', label: 'Дистрибьюторы: администратор' },
            { code: 'tms.action_log', label: 'Журнал действий TMS' },
            { code: 'tms.resync', label: 'TMS: ручной resync рейса' },
            { code: 'executor.confirm', label: 'Подтверждение перевозчика (зелёная галочка)' },
            { code: 'ati.route.manage', label: 'Ставки рейсов (редактирование)' },
            { code: 'calculator.use', label: 'Коммерческий калькулятор: использование' },
            { code: 'calculator.settings.read', label: 'Коммерческий калькулятор: просмотр настроек' },
            { code: 'calculator.settings.write', label: 'Коммерческий калькулятор: редактирование настроек' },
            { code: 'calculator.settings.publish', label: 'Коммерческий калькулятор: публикация настроек' },
            { code: 'calculator.finance.read', label: 'Коммерческий калькулятор: финансовые показатели' },
            { code: 'statistics.general', label: 'Статистика: общая' },
            { code: 'statistics.personal', label: 'Статистика: персональная' },
            { code: 'trip360.view', label: '360 рейса: просмотр' },
            { code: 'trip360.edit', label: '360 рейса: редактирование' },
        ];

        const permissions = computed(() => {
            const catalog = store.state.user.permissions_catalog;
            if (Array.isArray(catalog) && catalog.length) {
                return catalog.map((p, i) => ({ id: i + 1, code: p.code, label: p.label }));
            }
            return FALLBACK_PERMISSIONS.map((p, i) => ({ id: i + 1, code: p.code, label: p.label }));
        });

        const permissionMap = computed(() => {
            const map = {};
            permissions.value.forEach(p => map[p.code] = p.id);
            return map;
        });

        const fillForm = (source = blankform()) => {
            const permCodes = source.permissions || [];
            const permIds = permCodes
                .map(code => permissionMap.value[code])
                .filter(id => id !== undefined);
            Object.assign(form, blankform(), {
                id: source.id || null,
                name: source.name || '',
                permissions: permIds,
            });
        };

        const openCreate = () => {
            drawerMode.value = 'create';
            fillForm();
            panelOpen.value = true;
        }

        const openEdit = (source) => {
            drawerMode.value = 'edit';
            fillForm(source);
            panelOpen.value = true;
        }

        const closePanel = () => {
            panelOpen.value = false;
        };

        const payLoadFromForm = () => {
            const permIds = form.permissions || [];
            const permCodes = permIds
                .map(id => {
                    const found = permissions.value.find(p => p.id === id);
                    return found ? found.code : null;
                })
                .filter(code => code !== null);
            return {
                name: normalizeOptional(form.name),
                permissions: permCodes
            };
        };

        const filteredRoles = computed(() => {
            console.log(roles);
            return roles.value.filter((role) => {
                return [
                    role.id,
                    role.name,
                ];
            })
        });

        const roleItemsOptions = computed(() => {
            return permissions.value.map(item => ({
                id: item.id,
                label: `${item.label} (${item.code})`,
            }));
        });

        const saveRole = async () => {
            if (saving.value) {
                return;
            }
            saving.value = true;
            try{
                if (drawerMode.value === 'create') {
                    // TODO
                }
                else {
                    const result = await store.dispatch('updateRole', {
                        roleId: form.id,
                        data: payLoadFromForm(),
                    });
                    if (result?.id) {
                        toater.success('Роль обновлена');
                        closePanel();
                    }
                }
            }
            finally {
                saving.value = false;
            }
        };

        return {
            toater,
            permissions,
            permissionMap,
            roles,
            form,
            saving,
            drawerMode,
            panelOpen,
            filteredRoles,
            roleItemsOptions,
            openCreate,
            openEdit,
            closePanel,
            payLoadFromForm,
            saveRole,
        }
    }
}
</script>

<style scoped>
.roles-admin-page {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 14px 16px;
    color: #333;
}

.toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 10px;
}

.title-block {
    display: flex;
    align-items: baseline;
    gap: 10px;
}

h1,
h2 {
    margin: 0;
}

h1 {
    font-size: 22px;
    line-height: 1.2;
}

h2 {
    font-size: 18px;
}

.counter,
.drawer-subtitle,
.muted {
    color: #667085;
    font-size: 13px;
}

.controls,
.actions,
.drawer-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
}

.filters {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: flex-end;
    margin-bottom: 12px;
    padding: 10px;
    background: #f7f8fa;
    border: 1px solid #edf0f3;
    border-radius: 6px;
}

.field {
    display: flex;
    flex-direction: column;
    gap: 3px;
    color: #4b5563;
    font-size: 12px;
}

.field.wide {
    grid-column: 1 / -1;
}

.search-field {
    min-width: 280px;
}

.input,
.select {
    height: 32px;
    border: 1px solid #d7dce2;
    border-radius: 4px;
    background: #fff;
    color: #333;
    font-size: 13px;
    padding: 0 8px;
}

.input {
    min-width: 150px;
}

.select {
    min-width: 150px;
}

.btn,
.mini-btn,
.act-btn,
.close-btn,
.text-button {
    border: 1px solid #d7dce2;
    background: #fff;
    color: #333;
    cursor: pointer;
    font-size: 13px;
}

.btn {
    height: 32px;
    border-radius: 4px;
    padding: 0 12px;
}

.btn:hover,
.act-btn:hover,
.mini-btn:hover {
    border-color: #007bff;
    color: #007bff;
}

.btn.primary {
    background: #007bff;
    border-color: #007bff;
    color: #fff;
}

.btn:disabled {
    cursor: default;
    opacity: 0.6;
}

.filter-reset {
    margin-left: auto;
}

/*
.password-result,
.created-password {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  padding: 8px 10px;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 13px;
}

.password-result div {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
*/
.mini-btn {
    height: 26px;
    border-radius: 4px;
    padding: 0 8px;
    flex-shrink: 0;
}

.table-wrap {
    flex: 1;
    overflow: auto;
}

.roles-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: 13px;
}

.roles-table th,
.roles-table td {
    height: 32px;
    padding: 6px 8px;
    border-bottom: 1px solid #edf0f3;
    text-align: left;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.roles-table th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f7f8fa;
    color: #444;
    font-weight: 700;
}

.roles-table tbody tr:hover {
    background: #f3f6fb;
}

.col-id {
    width: 100px;
}

.col-name {
    width: 190px;
}

.status-badge,
.role-pill,
.tg-pill,
.soft-pill {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    border-radius: 10px;
    padding: 2px 7px;
    font-size: 12px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
}

/*
.status-active {
  background: #e6f4ea;
  color: #1e7e34;
}

.status-inactive {
  background: #fdeaea;
  color: #c0392b;
}

.role-pill {
  background: #e8eefc;
  color: #2563eb;
}

.tg-pill {
  background: #eef4ff;
  color: #0b63ce;
}

.soft-pill-blue {
  background: #e8eefc;
  color: #2563eb;
}

.soft-pill-green {
  background: #e6f4ea;
  color: #1e7e34;
}

.soft-pill-gray {
  background: #edf0f3;
  color: #667085;
}
*/

.text-button {
    padding: 0;
    border: 0;
    background: transparent;
    text-align: left;
}

.name-button {
    color: #0b63ce;
    font-weight: 600;
}

.name-button:hover {
    text-decoration: underline;
}

.act-btn {
    height: 26px;
    border-radius: 4px;
    padding: 0 7px;
    font-size: 12px;
}

.act-btn.danger {
    border-color: #e6a2a2;
    color: #9f2f2f;
}

.act-btn.success {
    border-color: #8fcaa6;
    color: #0b6b44;
}

.state-block {
    padding: 32px;
    color: #667085;
    font-size: 14px;
}

.modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(15, 23, 42, 0.45);
}

.modal {
    width: min(1200px, calc(100vw - 24px));
    max-height: 90vh;
    overflow-y: auto;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 20px 50px rgba(15, 23, 42, 0.25);
    padding: 22px;
    max-width: 90vw;
}

.drawer-header {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 16px;
}

.close-btn {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    font-size: 20px;
    line-height: 1;
}

.drawer-form {
    display: flex;         
    flex-direction: column; 
    gap: 20px; 
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 16px 24px;
    align-items: flex-start;
}

.drawer-form .input,
.drawer-form .select {
    width: 100%;
    min-width: 0;
}

.drawer-form .field,
.drawer-form .checkbox-field {
    grid-column: 1;
}

.checkbox-field {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #333;
    font-size: 13px;
}

.right-editor-grid {
    grid-column: 2;
    grid-row: 1 / span 10;
    align-self: stretch;
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
}

.row-card:hover {
    background-color: rgba(224, 187, 72, 0.4);
    cursor: pointer;
}
</style>
